import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'app-event-calendar',
    templateUrl: './event_calendar.component.html',
    styleUrls: ['./event_calendar.component.scss'],
    standalone: false
})
export class EventsCalendarComponent implements OnInit {
 static key = 100808;
  
  @Input('item') item:any
  @Input('pageKey') pageKey:any
  @Output('onSizeChange') onSizeChange = new EventEmitter<any>()
  @ViewChild('EventDUCalender',{static:true}) EventDUCalender!:ElementRef
  constructor() { }

  ngOnInit(): void {
    const observer = new ResizeObserver((e:any) => {
      this.onSizeChange.emit(e[0].contentRect.height)
    });
    observer.observe(this.EventDUCalender.nativeElement);
  }

}
